import VueRouter from 'vue-router';
import i18n from '@/i18n';
import store from '@/store';
import Home from '@/views/Home.vue';
import Proposition from '@/views/Proposition.vue';

const routes = [
    {
        path: '/',
        redirect: `/${i18n.locale}`
    },
    {
        path: '/:lang',
        component: {
            render (c) { return c('router-view') }
        },
        children: [
            {
                path: '/',
                name: 'Home',
                component: Home
            },
            {
                path: 'proposition',
                name: 'Proposition',
                component: Proposition
            }
        ],
    }
];

const router = new VueRouter({
    routes,
    mode: 'history'
});

router.beforeEach((to, from, next) => {
    const { lang } = to.params;
    const supportedLocales = process.env.VUE_APP_I18N_SUPPORTED_LOCALE.split(',');
    if (!supportedLocales.includes(lang)) {
        store.state.langDropdown = false;
        return next('en');
    }

    if (i18n.locale !== lang) {
        store.state.langDropdown = false;
        i18n.locale = lang;
    }

    setTimeout(function() {
        document.querySelector('header').scrollIntoView({
            behavior: 'smooth',
        });
    }, 100);

    return next();
});

export default router;